module.exports = __webpack_public_path__ + "img/img6.984b2464.png";